module.exports = __webpack_public_path__ + "static/estamos-bg-520147547b26b7c1ab2e2452521b9001.svg";